import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { MdErrorOutline } from 'react-icons/md';

import Modal from '../../../../components/Modal/Modal';
import {
  ButtonContainer,
  SmallerModal,
} from '../../styles/GerenciarContas.styles';
import TextInput from '../../../../components/TextInput/TextInput';
import Button from '../../../../components/Button/Button';
import { theme } from '../../../../styles/theme';
import {
  blockAccountFetchAction,
  unlockAccountFetchAction,
} from '../../../../store/fetchActions/accountActions';

const {
  warningColor,
  rbmWhite,
  secondaryColor,
  dangerColor,
  mainColor,
  rbmBlack,
} = theme?.colors;

const BlockUser = ({ openModal, closeModal, blockUser, idConta }) => {
  const dispatch = useDispatch();

  const blockOrUnlockUser = ({ justificativa }) => {
    let id = idConta;
    let param = { OBSERVACOES: justificativa };
    if (blockUser) {
      dispatch(blockAccountFetchAction(id, param, closeModal));
    } else {
      dispatch(unlockAccountFetchAction(id, param, closeModal));
    }

    reset({
      justificativa: '',
    });
  };

  const {
    handleSubmit: handleBlockUser,
    control: controlBlockUser,
    reset,
  } = useForm({});

  return (
    <Modal open={openModal} close={closeModal}>
      <SmallerModal>
        <MdErrorOutline color={warningColor} size={'6.944vw'} />
        <h3>{blockUser ? 'Bloquear conta' : 'Desbloquear conta'}</h3>
        <h5>
          Tem certeza que deseja {blockUser ? 'bloquear' : 'desbloquear'} a
          conta?
        </h5>
        <h4>Justificativa</h4>
        <form onSubmit={handleBlockUser(blockOrUnlockUser)}>
          <TextInput
            margin={'0'}
            variant={'outlined'}
            name={'justificativa'}
            width={'28.342vw'}
            multiline={true}
            minRows={3}
            required={true}
            size="large"
            control={controlBlockUser}
            inputProps={{ maxLength: 100 }}
          />
          <ButtonContainer>
            <Button
              backgroundColor={rbmWhite}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={rbmWhite}
              hoverColor={secondaryColor}
              color={secondaryColor}
              onClick={closeModal}
            >
              <span>Voltar</span>
            </Button>
            <Button
              backgroundColor={secondaryColor}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={blockUser ? dangerColor : mainColor}
              hoverColor={blockUser ? rbmWhite : rbmBlack}
              color={rbmWhite}
              type={'submit'}
              roleName={'button-confirmar-negar'}
            >
              <span>{blockUser ? 'Bloquear' : 'Desbloquear'}</span>
            </Button>
          </ButtonContainer>
        </form>
      </SmallerModal>
    </Modal>
  );
};

export default BlockUser;
